export default __webpack_public_path__ + "static/media/cssback.886e4680.svg";